import React from 'react';
import { cn } from './cn';

/**
 * EmptyState — icon + title + description + optional action.
 *
 * Props:
 *  - card: when true, wraps the content in a dashed-border surface card
 *          (the design-system "dashed empty-state card").
 */
export default function EmptyState({ icon: Icon, title, description, action, card = false, className }) {
  return (
    <div
      className={cn(
        'text-center',
        card
          ? 'rounded-ga-md border border-dashed border-ga-border-subtle bg-ga-bg-surface-subtle/30 px-6 py-12'
          : 'py-12',
        className
      )}
    >
      {Icon && (
        <div className="mb-4 text-ga-text-subtle">
          <Icon className="mx-auto h-12 w-12" aria-hidden />
        </div>
      )}
      {title && <h3 className="text-lg font-semibold text-ga-text-primary mb-2">{title}</h3>}
      {description && <p className="text-ga-text-muted mb-4 max-w-md mx-auto">{description}</p>}
      {action}
    </div>
  );
}
